import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

/* ---------- Slider Images ---------- */
import slide1 from "../../assets/media/ImageAnekant/solar.png";
import slide2 from "../../assets/media/ImageAnekant/cogen.png";
import slide3 from "../../assets/media/ImageAnekant/power.png";

/* ---------- Categories ---------- */
const categories = [
  {
    title: "Machinery / Suppliers",
    icon: "⚙️",
    path: "/suppliers",
  },
  {
    title: "Classified",
    icon: "📢",
    path: "/classifieds",
  },
];

function Category() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 700,
    autoplay: true,
    autoplaySpeed: 4500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="category-section py-4">
      <div className="container-fluid px-lg-5">
        <div className="row align-items-stretch">

          {/* ================= LEFT CATEGORY ================= */}
          <div className="col-lg-3 mb-3 mb-lg-0">
            <div className="category-box h-100">
              <h5 className="category-title">Categories</h5>

              {categories.map((cat, index) => (
                <Link
                  key={index}
                  to={cat.path}
                  className="category-item"
                >
                  <span className="category-icon">{cat.icon}</span>
                  <span>{cat.title}</span>
                </Link>
              ))}
            </div>
          </div>

          {/* ================= RIGHT SLIDER ================= */}
          <div className="col-lg-9">
            <div className="category-slider">
              <Slider {...sliderSettings}>
                {[slide1, slide2, slide3].map((img, index) => (
                  <div key={index}>
                    <div
                      className="category-slide"
                      style={{ backgroundImage: `url(${img})` }}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Category;
